import { Link } from "react-router-dom";
import dataJson from "@/../public/data.json";
import { publicPath } from "@/utils/base";
import "./index.less";
const tvHeaderPrefix = "header-account";

const HeaderAccount = () => {
  const { header } = dataJson;


  return (
    <div className={tvHeaderPrefix}>
      <img
        src={header.logo}
        alt=""
        className={`${tvHeaderPrefix}-logo`}
      />
      <div className={`${tvHeaderPrefix}-link`}>
        {header.has_account}
        <Link to={`${publicPath}/login`} className="login-link">
          {header.login_now}
        </Link>
      </div>
    </div>
  );
};
export default HeaderAccount;
